import React, { useEffect, useState } from 'react'
import { BrowserRouter, Route, Routes } from 'react-router-dom'
import Home from "./components/sections/Home/Home";
import Header from './components/layout/Header/Header';
import Footer from './components/layout/Footer/Footer';
import Error from './components/layout/Error/Error';
import Nosotros from './components/sections/Nosotros/Nosotros';
import WhatsApp from './components/layout/WhatsApp/WhatsApp';
import ScrollToTop from './components/layout/ScrollToTop/ScrollToTop';
import CategoriaProductos from './components/sections/Productos/CategoriaProductos/CategoriaProductos';
import ProductoPage from './components/sections/Productos/ProductosPage/ProductoPage';
import Productos from './components/sections/Productos/Productos';
import Faq from './components/sections/FAQ/Faq.jsx';
import ChatBotButton from './components/sections/ChatBot/ChatBotButton/ChatBotButton.jsx';
import { apiGet } from './api/api.js';
import { formatProductos } from './utilities/format/formatProductos.js';

const Router = () => {
    const [productosTop, setProductosTop] = useState([]);
    const [productos, setProductos] = useState([]);
    const [promociones, setPromociones] = useState([]);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const [productosTopRes, productosRes, promocionesRes] = await Promise.all([
                    apiGet('/homes'),
                    apiGet('/nuestros-productos'),
                    apiGet('/promociones'),
                ]);

                setProductosTop(formatProductos(productosTopRes, 'productosComponent'));
                setProductos(formatProductos(productosRes, 'nuestrosProductosComponente'));
                setPromociones(formatProductos(promocionesRes, 'promociones'));
            } catch (err) {
                console.error('❌ Error al obtener productos:', err);
            }
        };

        fetchData();
    }, []);

    return (
        <BrowserRouter>
            <Header />
            <Routes>
                <Route exact path="/" element={<Home />} />
                <Route exact path="/nosotros" element={<Nosotros />} />
                <Route exact path="/productos-top" element={<Productos data={productosTop} urlMainData="/productos-top" />} />
                <Route exact path="/productos-top/:categorySlug" element={<CategoriaProductos data={productosTop} urlMainData="/productos-top" />} />
                <Route exact path="/productos-top/:categorySlug/:productSlug" element={<ProductoPage data={productosTop} />} />
                <Route exact path="/sellos-de-seguridad" element={<Productos data={productos} urlMainData="/sellos-de-seguridad" showBanner={true} />} />
                <Route exact path="/sellos-de-seguridad/:categorySlug" element={<CategoriaProductos data={productos} urlMainData="/sellos-de-seguridad" />} />
                <Route exact path="/sellos-de-seguridad/:categorySlug/:productSlug" element={<ProductoPage data={productos} />} />
                <Route exact path="/preguntas-frecuentes" element={<Faq />} />
                <Route
                    exact
                    path="/promociones"
                    element={<Productos data={promociones} urlMainData="/promociones" showBanner={false} />}
                />
                <Route
                    exact
                    path="/promociones/:categorySlug"
                    element={<CategoriaProductos data={promociones} urlMainData="/promociones" />}
                />
                <Route
                    exact
                    path="/promociones/:categorySlug/:productSlug"
                    element={<ProductoPage data={promociones} />}
                />

                <Route exact path="*" element={<Error />} />
            </Routes>
            <WhatsApp />
            <ChatBotButton />
            <ScrollToTop />
            <Footer />
        </BrowserRouter>
    )
}

export default Router